import React, {useState} from 'react';
import numberFormat from "../../../helpers/numberFormat";
import _ from "lodash";

const GlobalReportsRow = ({secondaryRows, children, backgroundColor = "#cfe2f3"}) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <tr style={{backgroundColor}}>
        {children}
        <th style={{width:'24px'}}><i className={`fa fa-chevron-${show ? 'up' : 'down'} pointer`}
               onClick={() => {
                 setShow(!show)
               }}></i>
        </th>
      </tr>
      {show && secondaryRows}
    </>
  );
};

export default GlobalReportsRow;
